import { Typography } from '@mui/material';
import { useAccount } from '../../auth';
import { getPluralEntity } from '../../utils/entities';
import { theme, Link } from '../../utils/theme';
import { Flow as FlowType } from '../../types/flow.types';

interface FlowResourceDisplayProps {
  flow: FlowType | undefined;
  direction: 'source' | 'destination';
  schemaRelativePath?: string;
  sx?: {
    link?: React.CSSProperties;
    typography?: React.CSSProperties;
    image?: React.CSSProperties;
  };
}

const FlowResourceDisplay = ({
  flow,
  direction,
  schemaRelativePath,
  sx,
}: FlowResourceDisplayProps) => {
  const { currentAccount } = useAccount();
  if (!flow) return null;

  const resources =
    direction === 'source'
      ? [flow?.source]
      : [...new Set(flow?.destinations || [])];

  return (
    <>
      {resources?.map((srcOrDest) => (
        <span
          key={srcOrDest?.id}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Link
            style={{
              color: theme.palette.common.black,
              display: 'flex',
              alignItems: 'center',
              ...(sx?.link || {}),
            }}
            to={`/${currentAccount.name}/${getPluralEntity(srcOrDest?.entity_type)()}/configure/${srcOrDest?.type_name}/${srcOrDest?.name}`}
          >
            {srcOrDest?.img_url && (
              <img
                src={srcOrDest.img_url}
                style={{
                  maxHeight: '24px',
                  maxWidth: '48px',
                  paddingRight: `8px`,
                  ...(sx?.image || {}),
                }}
              />
            )}
            <Typography
              variant={'body2'}
              color="inherit"
              noWrap={true}
              sx={{ width: '100%', ...sx?.typography }}
              data-cy={`flow-resource-${direction}-name`}
            >
              {srcOrDest?.name}
            </Typography>
          </Link>

          {schemaRelativePath && (
            <span style={{ paddingLeft: theme.spacing(1) }}>
              {schemaRelativePath}
            </span>
          )}
        </span>
      ))}
    </>
  );
};
export default FlowResourceDisplay;
